import React from 'react';


const ClientNumber = (props) => {
  return (
    <section className="client_number section_space pt-0 pb-0">
        <div className="container">
            <div className="row">
            <div className='col-lg-12'>
                <ul className='hero_bottom_stats'>
                    <li>
                        <span className='number_css'>150+</span>
                        <span className='hero_bottom_text'>Satisfied <br/> SEO Clients</span>
                    </li>
                    <li>
                        <span className='number_css'>22+</span>
                        <span className='hero_bottom_text'>Industries <br/> Served</span>
                    </li>
                    <li>
                        <span className='number_css'>117+</span>
                        <span className='hero_bottom_text'>AI Automation <br/> Templates</span>
                    </li>
                </ul>                
            </div>
        </div>
        </div>
    </section>
  );
};

export default ClientNumber;